// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"9":"Contact","304":"Suit","787":"Suits"}[chunkId] || chunkId) + "." + {"9":"b276bf86","240":"25dfe81d","301":"24701436","304":"3c314fd1","347":"ca6c2fd8","358":"a9d6ef92","420":"2270ec77","572":"683fedff","711":"683fedff","756":"dd6fdee9","787":"be210883"}[chunkId] + ".css";
};